import { useFirebaseRemoteConfig } from 'Shared/services/firebase/hooks/useFirebaseRemoteConfig';

const REMOTE_CONFIG_ENABLED_KEY = 'sj_freshchat_enabled';

interface FreshChatEnabled {
  enabled: boolean;
  loading: boolean;
}

const useFreshChatEnabled = (): FreshChatEnabled => {
  const { data, isLoading } = useFirebaseRemoteConfig(REMOTE_CONFIG_ENABLED_KEY, 'boolean');

  return {
    enabled: !!data?.value,
    loading: isLoading,
  };
};

export default useFreshChatEnabled;
